import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
// styles
import { Dropdown_s } from 'styles/input-styles'
import { Label_s } from 'styles/app-styles'
// types
import { FolderReportProps } from './reports'

const displayName = 'Property Information'

type InformationType = 'attributes' | 'prop_info' | 'both'

export const propertyFilter = (property) => property.type === 'Commercial'

export const PropertyInformation: FC<FolderReportProps> = (props) => {
  const [information_type, setInformationType] = useState<InformationType>('both')

  const informationOptions = [
    { text: 'Property Attributes', value: 'attributes' },
    { text: 'Property Information', value: 'prop_info' },
    { text: 'Both', value: 'both' }
  ]

  useEffect(() => {
    props.setParameters({information_type, report: 'folder_property_information'})
  }, [information_type])
  
  return (
    <>
      <div>
        <Label_s>Information Type</Label_s>
        <Dropdown_s
          onChange={(e) => setInformationType(e.value)}
          optionLabel="text"
          options={informationOptions}
          value={information_type}
          wide
        />
      </div>
    </>
  )
}

PropertyInformation.displayName = displayName
export default PropertyInformation